import moment from "moment";

const formatValidityPeriod = (validity, format = "MMM DD, YYYY HH:mm") => {
  if (!validity || !validity?.fromDate || !validity?.toDate) return null;

  const fromDate = validity.startTime
    ? `${validity.fromDate} ${validity.startTime}`
    : `${validity.fromDate}`;
  const toDate = validity.endTime ? `${validity.toDate} ${validity.endTime}` : `${validity.toDate}`;

  return [
    moment(fromDate).format(validity.startTime ? format : "MMM DD, YYYY"),
    moment(toDate).format(validity.endTime ? format : "MMM DD, YYYY"),
  ].join(" - ");
};

export default formatValidityPeriod;
